import { FC } from 'react';

type Props = {
	className?: string;
};

const InfoCircle: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='inherit'
			className={className}>
			<path
				d='M17.9962 9.99993C17.9962 5.58162 14.4145 1.99987 9.99616 1.99987C5.57785 1.99987 1.99609 5.58162 1.99609 9.99993C1.99609 14.4182 5.57785 18 9.99616 18C14.4145 18 17.9962 14.4182 17.9962 9.99993Z'
				stroke='inherit'
				strokeWidth='1.20001'
			/>
			<path
				d='M10.1906 14.0002V10.0002C10.1906 9.62308 10.1906 9.43451 10.0735 9.31735C9.95632 9.2002 9.76775 9.2002 9.39062 9.2002'
				stroke='inherit'
				strokeWidth='1.20001'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.99203 6.7998H9.99922'
				stroke='inherit'
				strokeWidth='1.60001'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default InfoCircle;
